import clsx from "clsx"

import type { CaptionProps } from "./types"
import { getLineClampClass } from "../style"

export const captionClasses = ({ numberOfLines }: Pick<CaptionProps, "numberOfLines"> = {}) =>
  clsx("text-xs font-normal leading-[1.3]", getLineClampClass(numberOfLines))
